// extracted by mini-css-extract-plugin
module.exports = {"partnersLayout":"_30lYa"};